export class InstitutionModel {
    id: number;
    name: string;
    hasOutcomes: boolean;

    constructor() {
        this.id = 0;
        this.name = '';
        this.hasOutcomes = false;
    }
}


/** WEBPACK FOOTER **
 ** ./app/institution/models/InstitutionModel.ts
 **/